module.exports = __webpack_public_path__ + "img/trial.f15532fd.svg";